<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header" style="margin-bottom: 20px">
        {{ detail.name }}
        <Tag v-show="detail.default" color="success">По-умолчанию</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>

      <!-- CREATED DATE -->
      <div class="fs-15 color-grey mb-24">
        <Row>
          <Col span="12">
            Дата создания:
          </Col>
          <Col span="12">
            {{ formatDateTime(detail.created_date) }}
          </Col>
        </Row>

        <!-- IIN-->
        <Row>
          <Col span="12">
            ИИН/БИН:
          </Col>
          <Col span="12">
            {{ detail.inn }}
          </Col>
        </Row>

        <!-- PHONE-->
        <Row>
          <Col span="12">
            Телефон:
          </Col>
          <Col span="12">
            {{ detail.phone }}
          </Col>
        </Row>

        <!-- EMAIL-->
        <Row>
          <Col span="12">
            Email:
          </Col>
          <Col span="12">
            {{ detail.email }}
          </Col>
        </Row>

        <!-- birth_date-->
        <Row>
          <Col span="12">
            Дата рождения:
          </Col>
          <Col span="12">
            {{ detail.birth_date }}
          </Col>
        </Row>

        <!-- gender -->
        <Row>
          <Col span="12">
            Пол:
          </Col>
          <Col span="12">
            <span v-if="detail.gender === 'FEMALE'">Женский</span>
            <span v-if="detail.gender === 'MALE'">Мужской</span>

          </Col>
        </Row>
      </div>


      <!-- RECENT OPERATIONS -->
      <div style="text-align: center;">
        <RadioGroup v-model="doc_tab_switch" type="button">
          <Radio :label="doc_tab_switch_labels[0]"></Radio>
          <Radio :label="doc_tab_switch_labels[1]"></Radio>
        </RadioGroup>
      </div>
      <recentProductOrders
        v-if="doc_tab_switch === doc_tab_switch_labels[0]"
        style="min-height: 20%; margin-top: 20px"
        filter_by="customer"
        :filter_by_id="id"
        extra_param="type"
        :extra_param_value="order_type"
        :debt_status = "true"
      >
      <!-- <template v-slot:closedStatus="{ doc }">
      <div v-if="" style="color: red; text-align: right;">
        Закрыт
      </div>
      </template> -->
      <template v-slot:repaymentForm="{ doc }">
        <Button v-if="!doc.is_closed" @click="openDebtRepayment(doc.id, doc.cash, doc.is_fiscal)">Погасить</Button>
        <template v-else>
          <Button v-if="doc.receipt || is_receipt_recieved" type="primary" class="price" @click="fetchReportText(doc.id)"
                  style="border: none; color: #5087DE; text-decoration: underline; background: none; box-shadow: none; font-weight: bold;">
            Просмотр чека
          </Button>
          <Button v-else type="primary" class="price" @click="postDocTicket(doc.id)"
                  style="border: none; color: #5087DE; text-decoration: underline; background: none; box-shadow: none; font-weight: bold">
            Пробитие чека
          </Button>
        </template>
      </template>
      </recentProductOrders>

      <recentMoneyOrders
        v-else
        style="min-height: 20%; margin-top: 20px"
        filter_by="customer"
        :filter_by_id="id"
        extra_param="order_type"
        :extra_param_value="order_type"
      ></recentMoneyOrders>
    </div>
    
    <div class="ls_drawer_footer" style="margin-top: 50px">
      <Button style="margin-right: 15px" type="primary" @click="cancelAction()"><Icon type="md-close" /></Button>
      <Button v-if="display_edit_button" style="margin-right: 15px" type="info" @click="editAction()"><Icon type="md-create" /></Button>
      <Button v-if="display_delete_button" type="error" @click="removeModal = true" style="float: left; margin-right: 15px"
        ><Icon type="md-trash" />
      </Button>
    </div>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данного должника?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction()">
          Удалить
        </Button>
      </Row>
    </Modal>

    <Modal v-model="modalReport"
            title="Чек"
            width="300"
            cancelText="Закрыть"
            okText="Печать"
            :styles="{top: '20px'}"
    >
        <div class="report_body" id="ticketModalBodyPrint">
            <h2 v-if="is_receipt_fetched === true" class="report_header">ДУБЛИКАТ</h2>
            <div class="report_text">{{ reportText }}</div>
            <div class="report_qr">
                <qrcode-vue :value="qrValue" level="H"></qrcode-vue>
            </div>
        </div>
        <div slot="footer">
            <Button type="success" size="large" @click="modalPrint">Печать</Button>
            <Button type="error" size="large" @click="modalClose">Закрыть</Button>
        </div>
    </Modal>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>

</template>

<script>
import { BaseDetailData } from "../../base/base_detail.js";
import recentProductOrders from "../../components/core/recentProductOrders";
import recentMoneyOrders from "../../components/core/recentMoneyOrders";
import { TYPE_DEBT_SELL } from "../product_order/const";
import { base_url } from "../../http";
import debtRepaymentForm from "@/apps/debtor/debtRepaymentForm.vue";
import QrcodeVue from 'qrcode.vue'
// import debtRepayment from '@/apps/debtor/debtRepayment.vue';

let _app = BaseDetailData();
_app.data = function() {
  return {
    loading: true,
    detail: {},

    //  Additional nested data
    sections: [],
    showAddSectionModal: false,
    formSectionData: {
      name: ""
    },

    doc_tab_switch: "Долги",
    doc_tab_switch_labels: ["Долги", "Погашения"],

    order_type: TYPE_DEBT_SELL,

    removeModal: false,
    removeId: null,
    footerHide: true,

    modalReport: false,
    is_receipt_recieved: false,
    is_receipt_fetched: false,
    reportText: "",
    qrValue: "",
  };
};
_app.components = {
  recentProductOrders,
  recentMoneyOrders,
  debtRepaymentForm,
  QrcodeVue
  //debtRepayment
};
_app.methods.editAction = function() {
  this.$router.push({
    name: this.item_type + "_edit",
    params: { id: this.id }
  });
};
_app.methods.openDebtRepayment = function(order_id, cash_id, order_is_fiscal) {
  let counterpart = {type: "customer", id: this.detail.id}

  this.$router.push({
    name: "money_order_create",
    // name: "debt_repayment_create",
    query: { 
      type: "coming", product_order: order_id, isDebtRepayment: true, counterpart_id: counterpart.id, 
      debt_sum: this.detail.total_debt, is_fiscal: order_is_fiscal, cash: cash_id }
  });
};
_app.methods.postDocTicket = function(order_id) {
    const url = `${base_url}/product_orders/${order_id}/receipt/`;
    this.$http
      .post(url)
      .then(result => {
        this.reportText = this.b64DecodeUnicode(result.data.receipt);
        this.qrValue = this.b64DecodeUnicode(result.data.ofd_qr);
        this.modalReport = true;
        this.is_receipt_recieved = true;
      })
      .catch(error => {
        this.$Message.error("Произошла ошибка. Попробуйте позже.");
        console.log(error);
      });
  };
_app.methods.fetchReportText = function (ticket_id) {
  const url = `${base_url}/operations/${ticket_id}/`;
  this.$http
    .get(url)
    .then(result => {

        this.reportText = this.b64DecodeUnicode(result.data.receipt);
        this.qrValue = this.b64DecodeUnicode(result.data.ofd_qr);

        this.modalReport = true;
        this.is_receipt_fetched = true;
    })
    .catch(error => {
        this.$Message.error("Произошла ошибка");
    });
};
_app.methods.b64DecodeUnicode = function(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(
            atob(str)
                .split("")
                .map(function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
};
_app.methods.modalPrint = function() {
  printJS({
      printable: 'ticketModalBodyPrint',
      type: 'html',
      style: `.report_body {
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  font-family: Consolas, serif;
  font-size: 8px;
  font-weight: 400;
  line-height: 15px;
  overflow-wrap: break-word;
  pointer-events: auto;
  text-align: left;
  white-space: pre-wrap;
}
.report_header {
  font-size: 18px;
  font-weight: 400;
  text-align: center;
 }

.report_text {
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-family: Consolas;
  line-height: 15px;
  font-size: 15px;
  font-weight: 400;
  font-style: normal;
  color: #000;
  background-color: transparent;
}
  .report_qr {
    max-width: 233px;
    margin: 0 auto;
    text-align: center;
  }
`

  });
};
_app.methods.modalClose = function () {
    this.modalReport = false;
};
export default _app;
</script>

<style scoped>

.report_body {
    /*width: 420px;*/
    box-sizing: border-box;
    color: rgb(0, 0, 0);
    font-family: Consolas, serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 15px;
    overflow-wrap: break-word;
    pointer-events: auto;
    text-align: left;
    white-space: pre-wrap;
  }

  .report_header {
    /*color: rgb(42, 42, 42);*/
    font-size: 18px;
    font-weight: 500;
    line-height: 19.2px;
    /*margin-bottom: 8px;*/
    /*margin-top: 0px;*/
    /*pointer-events: auto;*/
    text-align: center;
    /*visibility: visible;*/
  }

  .report_text {
    display: flex;
    justify-content: center;
    overflow: hidden;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    font-family: Consolas;
    line-height: 15px;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    color: #000;
    background-color: transparent;
  }

  .report_qr {
    max-width: 233px;
    margin: 0 auto;
    text-align: center;
  }
  </style>



// WEBPACK FOOTER //
// src/apps/debtor/debtorDetail.vue